import "./styles.css";
import 'antd/dist/antd.css';
import { DataContextProvider } from "./contexts/runesContext";
import Login from "./routes/Login";

function App() {
  return <DataContextProvider> <Login /></DataContextProvider> ;
}

export default App;
